export default __webpack_public_path__ + "static/media/cLogo9.018666b1.jpeg";